import { getPropsFromNode, nodeIs, nodeMatches } from '../../utils'
import { ArticleFigure } from '../../../components/molecule/ArticleContent/entry'
import { getAlignmentProps } from '../_utils'
import { h } from '../../parser/utils'

import { parseCaption } from './image'

const ASPECT_RATIO_REGEX = /wp-embed-aspect-(\d+)-(\d+)/

export const NAME = 'block-embed'

// TODO: custom component for embeds for responsive youtube videos
export const COMPONENTS = {
  ArticleFigure,
}

export function matches(node) {
  return nodeMatches(node, '.wp-block-embed')
}

export async function transform (node, next, ctx) {
  const figure = nodeIs(node, 'figure') ? node : node.querySelector('figure')

  const wrapper = figure.querySelector('.wp-block-embed__wrapper')

  const captionNode = figure.querySelector('figcaption')

  const [caption, children] = await Promise.all([
    parseCaption(
      captionNode,
      next,
      ctx,
    ),
    next(wrapper.childNodes, ctx),
  ])

  const props = {
    ...getPropsFromNode(node, ['id', 'class', 'style']),
    ...(figure !== node ? getPropsFromNode(figure, ['id', 'class', 'style']) : {}),
    ...getAlignmentProps(node),
    boxed: {
      withBackground: true,
    },
    caption: caption.length ? caption : undefined,
    children,
  }

  const hasAspectRatio = nodeMatches(node, '.wp-has-aspect-ratio')

  if (hasAspectRatio) {
    const ratioClassName = Array.from(node.classList.values())
      .find((value = '') => value.match(ASPECT_RATIO_REGEX)) || ''

    const details = ratioClassName.match(ASPECT_RATIO_REGEX)

    if (details) {
      props.ratio = {
        width: parseInt(details[1], 10) || undefined,
        height: parseInt(details[2], 10) || undefined,
      }
    }
  }

  return h(ArticleFigure, props)
}
